import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, renderList as _renderList } from "./../../vue/dist/vue.runtime.esm-bundler.js";
import { useMediaQuery } from "./../../@vueuse/core/dist/index.js";
import { useTemplateRef, watch } from "./../../vue/dist/vue.runtime.esm-bundler.js";
import { useCurrentSection } from "./../composables/useCurrentSection.ts";
export default {
  __name: "Contents",
  props: { headings: {
    type: Array,
    required: true
  } },
  setup(__props) {
    const props = __props;
    const breakpoint = getComputedStyle(document.documentElement).getPropertyValue("--breakpoint-wide").trim();
    const wide = useMediaQuery(`(min-width: ${breakpoint})`);
    const current = useCurrentSection(props.headings.map((heading) => heading.id));
    const links = useTemplateRef("links");
    // The sidebar is wholly on screen, so this scrolls only the sidebar, never the page.
    watch(current, (id) => {
      if (wide.value) links.value?.find((link) => link.hash === `#${id}`)?.scrollIntoView({ block: "nearest" });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("details", { open: _unref(wide) || undefined }, [_createElementVNode("summary", {
        id: "toc-title",
        class: "cursor-pointer font-medium wide:cursor-default wide:list-none wide:[&::-webkit-details-marker]:hidden",
        tabindex: _unref(wide) ? -1 : undefined,
        onClick: _cache[0] || (_cache[0] = (event) => _unref(wide) && event.preventDefault())
      }, " Contents ", 8, ["tabindex"]), _createElementVNode("div", null, [_createElementVNode("ol", { class: "pt-2" }, [(_openBlock(true), _createElementBlock(
        _Fragment,
        null,
        _renderList(__props.headings, (heading) => {
          return _openBlock(), _createElementBlock("li", { key: heading.id }, [_createElementVNode("a", {
            ref_for: true,
            ref_key: "links",
            ref: links,
            class: _normalizeClass(["block border-l-2 border-rule py-0.5 text-dim no-underline transition-colors duration-(--duration-hover) hover:text-copy current:border-accent current:text-copy", heading.level > 2 ? "pl-6" : "pl-3"]),
            href: `#${heading.id}`,
            "aria-current": heading.id === _unref(current) ? "location" : undefined
          }, _toDisplayString(heading.text), 11, ["href", "aria-current"])]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))])])], 8, ["open"]);
    };
  }
};
